import { useEffect, useState } from 'react';

// Hash routing, same URL scheme as the NTN prototype: #/route/param/param
function read(): string[] {
  return location.hash.replace(/^#\/?/, '').split('/').filter(Boolean).map(decodeURIComponent);
}

export function useHashRoute(): { route: string; params: string[] } {
  const [parts, setParts] = useState<string[]>(read);
  useEffect(() => {
    const on = () => setParts(read());
    window.addEventListener('hashchange', on);
    return () => window.removeEventListener('hashchange', on);
  }, []);
  return { route: parts[0] ?? 'command', params: parts.slice(1) };
}

export function navigate(...parts: string[]): void {
  location.hash = '/' + parts.map(encodeURIComponent).join('/');
}
